import { Box, Chip, Grid, Link } from '@material-ui/core';
import React, { useRef, useState } from 'react';

import { RouteNames } from '../../pages/config';
import { HomeType, ISegmentCuration } from '../../services/types';
import { convertFirstCharacterToUppercase } from '../../services/utils';
import { getSegmentCurationTypeToHomeType } from './Popovers';
import useStyles from './styles';

interface LCProps {
  linkedCurations?: ISegmentCuration[];
}

export const LinkedSegments = (props: LCProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid container>
      {props.linkedCurations && props.linkedCurations?.length > 0 && (
        <Grid item xs={12} className={classes.linkedCurationsWrap}>
          {props.linkedCurations?.map(curation => {
            const curationType =
              getSegmentCurationTypeToHomeType(curation.type) === HomeType.ALL
                ? 'Default'
                : ((getSegmentCurationTypeToHomeType(curation.type) as unknown) as string);
            return (
              <Box key={`child-curation-key-${curation.id!}`} display="flex" className={classes.linkedCurationItem}>
                <Chip
                  size="small"
                  label={curation.segment!.isActive ? 'Activated' : 'Deactivated'}
                  color={curation.segment!.isActive ? 'primary' : 'default'}
                  style={{ marginRight: 8 }}
                />
                <Link href={`${RouteNames.UserSegment}/v/${curation.segment!.id!}/curation`} target="_blank" className={classes.linkedCurationTitle}>
                  {curation.segment?.name}
                </Link>
                <span className={classes.linkedCurationUserCount}>({curation.segment?.userCount?.toLocaleString() || 0})</span>
                <div className={classes.linkedHomeType}>{convertFirstCharacterToUppercase(curationType) || '-'}</div>
              </Box>
            );
          })}
        </Grid>
      )}
    </Grid>
  );
};
